export default {
  apiKey: "AIzaSyDWP2OEf9-PSrclquuQ86qNuautWgZvq-Y",
  authDomain: "typefasterer-b6cf7.firebaseapp.com",
  projectId: "typefasterer-b6cf7",
  storageBucket: "typefasterer-b6cf7.appspot.com",
  messagingSenderId: "880099538426",
  appId: "1:880099538426:web:6925ab3e2af896723e2043",
  measurementId: "G-VGVL2VGWTZ"
};
